export default __webpack_public_path__ + "static/media/bear.b4455cc1.png";